import { track, logError } from '@tracking';
import { getSearchId } from '@tracking/services/location.service';
import getShopBusinessType from '@core/reducers/shop/selectors/getShopBusinessType';
import getSessionId from '@core/reducers/user/selectors/getSessionId';

const EVENT_NAME = 'map.loaded';

const trackMapLoaded = ({ mapType, origin }) => async (_, getState) => {
  try {
    const state = getState();
    const searchId = getSearchId();
    const dbSearchGuid = getSessionId(state);
    const businessType = getShopBusinessType(state);

    const payload = { mapType, searchId, dbSearchGuid, origin, businessType };

    track(EVENT_NAME, payload);
  } catch (error) {
    logError(EVENT_NAME, error);
  }
};

export default trackMapLoaded;
